import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid2,
  IconButton,
  TextField,
  useTheme,
} from "@mui/material";
import TableComponent from "components/grid";
import PaginationComponent from "components/ui-components/PaginationComponent";
import * as React from "react";
import { IoMdClose } from "react-icons/io";

const columns = [
  {
    name: "Category",
    field: "category",
  },
  {
    name: "Quantity",
    field: "qty",
  },
  {
    name: "Manpower",
    field: "manpower",
  },
  {
    name: "U.O.M.",
    field: "uom",
  },
  {
    name: "Productivity",
    field: "productivity",
  },
];

export default function ProceedNormsActualDetail(props) {
  const { open, cancel, actualValues, handleApprove, updateManpowerRes } =
    props;
  const theme = useTheme();

  const [pageNumber, setPageNumber] = React.useState(1);
  const [rowsPerPage] = React.useState(10);

  const paginatedData = React.useMemo(() => {
    const startIndex = (pageNumber - 1) * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    return actualValues?.slice(startIndex, endIndex);
  }, [actualValues, pageNumber, rowsPerPage]);

  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={cancel}
        disableEnforceFocus
        disableRestoreFocus
        aria-labelledby="draggable-dialog-title"
        fullWidth={true}
        maxWidth={"md"}
      >
        <DialogTitle
          sx={{
            fontWeight: 500,
            fontSize: "20px",
            color: "#252525",
            paddingBottom: 0,
          }}
          id="draggable-dialog-title"
        >
          Please review the changes
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={cancel}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          }}
        >
          <IoMdClose style={{ fontSize: "20px" }} />
        </IconButton>
        <DialogContent>
          <Grid2 size={{ md: 12 }} sx={{ mt: 2 }}>
            <TableComponent columns={columns} data={paginatedData} />
            <Box sx={{ display: "flex", justifyContent: "end" }}>
              <PaginationComponent
                pageNumber={pageNumber}
                totalPages={Math.ceil(actualValues.length / rowsPerPage)}
                onPageChange={(page) => setPageNumber(page)}
              />
            </Box>
          </Grid2>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            onClick={handleApprove}
            loading={updateManpowerRes?.isLoading}
            sx={{
              backgroundColor: `${theme?.customSettings?.themeColor}`,
              color: "#fff",
              fontSize: "16px",
              fontWeight: "500",
              textTransform: "none",
            }}
          >
            Proceed
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
